import location from '~/mixins/location'

export default {
    mixins: [location],

    methods: {
        getFormattedName(guest, withTitle = false) {
            const title = withTitle ? (guest.title ? guest.title + ' ' : '') : ''
            if (!guest.first_name && !guest.last_name) return 'Name unknown'
            return `${title}${guest.first_name} ${guest.last_name}`
        },

        hasAddress(guest) {
            // && guest.country
            return guest.address && guest.city && guest.zip && guest.state
        },
    },
}
